import type Pagination from '~/type/Pagination'

export default function (el: { [key: string]: any }): Pagination {
  return {
    count: el.COUNT,
    current: el.CURRENT,
    itemQuantity: el.ROWS,
  }
}
